import { render, staticRenderFns } from "./StzhUnprotectedViewHeader.vue?vue&type=template&id=71e5f474&scoped=true"
import script from "./StzhUnprotectedViewHeader.vue?vue&type=script&lang=js"
export * from "./StzhUnprotectedViewHeader.vue?vue&type=script&lang=js"
import style0 from "./StzhUnprotectedViewHeader.vue?vue&type=style&index=0&id=71e5f474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e5f474",
  null
  
)

export default component.exports